import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  loading() {
    this.element.classList.add("is-loading")

    const originalText = this.element.textContent
    this.element.setAttribute("data-original-text", originalText)
    this.element.textContent = "Loading..."

    // Disable the button after a small delay to allow form submission
    setTimeout(() => {
      this.element.disabled = true
    }, 100)

    // Restore after 10 seconds as a fallback
    setTimeout(() => {
      this.restore()
    }, 10000)
  }

  restore() {
    const originalText = this.element.getAttribute("data-original-text")
    if (originalText) {
      this.element.textContent = originalText
      this.element.removeAttribute("data-original-text")
    }
    this.element.classList.remove("is-loading")
    this.element.disabled = false
  }
}
